/* ===================== DATA =====================
   NOTE: the old hardcoded PRODUCTS array lived here and was the source of the price drift
   (landing page said $369.99 while Shopify charged $2,500, and it kept advertising products
   that had been switched to Draft). All product data is now server-rendered from Shopify in
   sections/landing.liquid. Never reintroduce a hardcoded product list. */
const SHOP="";
/* Chassis are PAIRED where the platform is shared (same engine + same fitment), so owners see
   one tile per real fitment group instead of near-duplicates. Models with no pair stand alone. */
const MODELS=[
  {h:"x3m-x4m-f97-f98",name:"X3M / X4M",sub:"F97 · F98 · S58",img:"frontlip-hero"},
  {h:"x5m-x6m-f95-f96",name:"X5M / X6M",sub:"F95 · F96 · S68",img:"model-x5m-x6m",soon:true},
  {h:"x3-x4-m40i",name:"X3 M40i / X4 M40i",sub:"G01 · G02 · B58",img:"model-x3-m40i",soon:true},
  {h:"x5-x6-m50i",name:"X5 M50i / X6 M50i",sub:"G05 · G06 · B58",img:"model-x5-m50i",soon:true},
  {h:"x5-x6-m60i",name:"X5 M60i / X6 M60i",sub:"G05 · G06 LCI · S68",img:"model-x5-m60i",soon:true},
  {h:"x3-m50i",name:"X3 M50i",sub:"G45 · B58",img:"model-x3-m50i",soon:true},
];
const ICONS={
  exhaust:'<path d="M3 12h2l2-3h6l2 3h6"/><circle cx="7" cy="16" r="2"/><circle cx="17" cy="16" r="2"/>',
  carbon:'<path d="M12 2 2 7l10 5 10-5z"/><path d="m2 17 10 5 10-5M2 12l10 5 10-5"/>',
  grille:'<rect x="4" y="5" width="16" height="14" rx="1"/><path d="M8 5v14M12 5v14M16 5v14"/>',
  light:'<circle cx="12" cy="12" r="4"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3M5 5l2 2M17 17l2 2M19 5l-2 2M7 17l-2 2"/>',
  splitter:'<path d="M3 15h18M5 15l2-4h10l2 4M8 15v3M16 15v3"/>',
  car:'<path d="M5 13l1.5-4.5A2 2 0 0 1 8.4 7h7.2a2 2 0 0 1 1.9 1.5L19 13M5 13h14v4H5z"/><circle cx="8" cy="17" r="1.4"/><circle cx="16" cy="17" r="1.4"/>',
  wrench:'<path d="M14 7a4 4 0 0 1-5 5L4 17l3 3 5-5a4 4 0 0 0 5-5z"/>'
};
function svg(n,s=24,sw=1.1){return `<svg width="${s}" height="${s}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="${sw}" stroke-linecap="round" stroke-linejoin="round">${ICONS[n]||ICONS.car}</svg>`;}
function money(n){return '$'+n.toFixed(2);}

/* ===================== LANDING-ONLY GUARD =====================
   landing.js is loaded on every page, but everything below this point writes to
   DOM nodes that only exist in sections/landing.liquid. Without this guard the
   first getElementById(...) returns null on a PDP/collection/cart page and the
   TypeError kills every statement after it. The shared header/reveal IIFE at the
   bottom of this file lives OUTSIDE the guard so it still runs everywhere. */
if(document.getElementById('catGrid')){

/* ===================== ANNOUNCEMENT ===================== */
document.getElementById('annClose').addEventListener('click',()=>document.getElementById('announce').classList.add('hide'));

/* ===================== SHOP BY CATEGORY ===================== */
document.getElementById('catGrid').innerHTML=MODELS.map(c=>{
  var src=c.img&&window.HPRM_MODEL_IMG?window.HPRM_MODEL_IMG[c.img]:null;
  var style=src?` style="background-image:linear-gradient(180deg,rgba(23,21,15,0) 42%,rgba(23,21,15,.82)),url('${src}')"`:'';
  var badge=c.soon?`<span class="mt-soon">Coming Soon</span>`:'';
  return `<a class="model-tile${src?'':' noimg'}${c.soon?' soon':''}" href="${SHOP}/collections/${c.h}"${style}>${badge}${src?'':`<div class="mt-ico">${svg(c.icon||'car',44,1)}</div>`}<div class="mt-meta"><div class="mt-name">${c.name}</div><div class="mt-sub">${c.sub}</div></div></a>`;
}).join('');

/* ===================== PRODUCT GRID =====================
   The Best Sellers grid is now SERVER-RENDERED in sections/landing.liquid straight from the
   Shopify "Best Sellers" collection, so prices/titles/images/stock can never drift from Admin
   again. Nothing to do here — do not reintroduce a hardcoded PRODUCTS array. */

/* ===================== BUILD YOUR KIT =====================
   Rows are server-rendered too; this only does the selection + tier math, reading the real
   variant id and price off each row's data attributes. */
const kitEls=[].slice.call(document.querySelectorAll('.kit-item'));
const selected=new Set();
function tierFor(n){return n>=4?10:n>=2?5:0;}
function renderKit(){
  const chosen=kitEls.filter((el,i)=>selected.has(i));
  const n=chosen.length;
  const sub=chosen.reduce((s,el)=>s+(parseInt(el.dataset.price,10)||0),0)/100;
  const pct=tierFor(n), disc=sub*pct/100;
  document.getElementById('kitCount').textContent=`${n} item${n===1?'':'s'} selected`;
  document.getElementById('kitSub').textContent=money(sub);
  document.getElementById('kitPct').textContent=pct;
  document.getElementById('kitDisc').textContent='–'+money(disc);
  document.getElementById('kitTotal').textContent=money(sub-disc);
  document.querySelectorAll('.tier').forEach(t=>{const tv=+t.dataset.tier;t.classList.toggle('hit',tv<=pct);});
  const btn=document.getElementById('kitCheckout');
  if(n===0){btn.style.pointerEvents='none';btn.style.opacity='.4';btn.textContent='Select to begin';btn.href='#';}
  else{btn.style.pointerEvents='auto';btn.style.opacity='1';
    const code=n>=4?'KIT10':n>=2?'KIT5':'';
    const path=chosen.map(el=>`${el.dataset.vid}:1`).join(',');
    btn.href=`/cart/${path}${code?`?discount=${code}`:''}`;
    btn.textContent=pct>0?`Add to Build — Save ${pct}%`:`Add to Build — ${money(sub)}`;}
}
kitEls.forEach((el,i)=>el.addEventListener('click',()=>{
  if(selected.has(i)){selected.delete(i);el.classList.remove('on');}else{selected.add(i);el.classList.add('on');}
  renderKit();
}));
if(kitEls.length)renderKit();

/* ===================== PRODUCT CAROUSEL ===================== */
(function(){
  var rail=document.getElementById('carousel');
  if(!rail)return;
  var prev=document.getElementById('carPrev'), next=document.getElementById('carNext');
  // Advance by (visible cards - 1) so there's always one card of overlap for orientation.
  function step(){
    var c=rail.querySelector('.ccard');
    if(!c)return rail.clientWidth*0.8;
    var gap=parseFloat(getComputedStyle(rail).columnGap||getComputedStyle(rail).gap)||14;
    var w=c.getBoundingClientRect().width+gap;
    return w*Math.max(1,Math.floor(rail.clientWidth/w)-1);
  }
  function sync(){
    if(!prev||!next)return;
    var max=rail.scrollWidth-rail.clientWidth-2;
    prev.disabled=rail.scrollLeft<=2;
    next.disabled=rail.scrollLeft>=max;
  }
  if(prev)prev.addEventListener('click',function(){rail.scrollBy({left:-step(),behavior:'smooth'});});
  if(next)next.addEventListener('click',function(){rail.scrollBy({left:step(),behavior:'smooth'});});
  rail.addEventListener('scroll',sync,{passive:true});
  window.addEventListener('resize',sync);
  rail.addEventListener('keydown',function(e){
    if(e.key==='ArrowRight'){e.preventDefault();rail.scrollBy({left:step(),behavior:'smooth'});}
    if(e.key==='ArrowLeft'){e.preventDefault();rail.scrollBy({left:-step(),behavior:'smooth'});}
  });
  sync();
})();

/* ===================== SERVICES ===================== */
const SVC=[
  {icon:"wrench",name:"ZF8 Transmission Tuning",d:"Factory-flat shifts, recalibrated. Faster, firmer, the way it should have left Munich.",links:[["Shop the Tune","/collections/services-tuning"]]},
  {icon:"car",name:"Car Buying Concierge",d:"Done-for-you sourcing and negotiation. Stop overpaying on your next performance BMW.",links:[["Book the Service","/collections/services-tuning"]]},
  {icon:"light",name:"Custom Logo Projectors",d:"Your badge, initials, or design projected under the door. Made to order.",links:[["Personalize Yours","/products/custom-logo-led-door-projector-lights-your-badge-initials-or-design"]]},
];
document.getElementById('svcGrid').innerHTML=SVC.map(s=>`
  <div class="svc">
    <div class="sv">${svg(s.icon,60,1)}</div>
    <h3>${s.name}</h3>
    <p>${s.d}</p>
    <div class="links">${s.links.map(l=>`<a class="ulink" href="${SHOP}${l[1]}">${l[0]}</a>`).join('')}</div>
  </div>`).join('');

/* ===================== FAQ ===================== */
const FAQS=[
  ["Why buy from HPRM Motorsports?",`
    <p class="intro">This isn't a traditional parts store — it's a curated collection of components I personally run, test and stand behind.</p>
    <ul>
      <li>No guesswork — every product is tested</li>
      <li>No generic listings — only curated parts</li>
      <li>Only proven results, backed by real-world miles</li>
      <li>Reviews, installs and real-world feedback are documented on my YouTube channel and Instagram</li>
    </ul>
    <p>If it's not good enough for my own car, it doesn't go on the site.</p>`],
  ["What is the return policy?",`
    <p class="intro">Returns are accepted within 14 days of delivery. Select products may qualify for an extended return window — eligibility and terms are clearly stated within the product description.</p>
    <ul>
      <li>Items must be unused, uninstalled, and in original condition. Returns will not be accepted for products that have been test fitted, installed, or show any signs of mounting, wear, or modification.</li>
      <li>A restocking fee of 20% applies. Return shipping costs are the responsibility of the buyer.</li>
      <li>If an item arrives defective or non-functional — a verified issue that prevents the product from operating as intended — you're eligible for a replacement or refund.</li>
      <li>Cosmetic imperfections or minor blemishes do not qualify as defects.</li>
      <li>Items damaged during shipping will be replaced or exchanged accordingly. Please inspect your package upon delivery; any damage must be reported within 24 hours of delivery.</li>
      <li>All shipments require signature confirmation. Once marked as delivered by the courier, HPRM Motorsports is not responsible for lost or missing packages.</li>
    </ul>`],
  ["When will my items ship?",`
    <ul>
      <li>All orders require a signature upon delivery to ensure safe and secure arrival.</li>
      <li>Delivery timeframes vary depending on the carrier and destination.</li>
      <li>Shipping rates are automatically calculated at checkout.</li>
      <li>HPRM Motorsports currently ships within the 48 contiguous states.</li>
    </ul>`],
  ["What is shipping protection?",`
    <p class="intro">A 5% surcharge will be added to protect your shipment in transit. It's optional — you choose whether to add it in your cart.</p>
    <ul>
      <li><b>If insured</b>, HPRM Motorsports will handle any packages damaged or lost by the shipping carrier, and will replace the lost or damaged items. <b>Stolen packages are not covered under any circumstances.</b></li>
      <li><b>If not insured</b>, the customer takes full responsibility in cases of damaged or lost packages. HPRM Motorsports will cover no reimbursement or replacement. The customer will handle the lost or damaged item case directly with the shipping company.</li>
    </ul>`],
  ["What is the order cancellation policy?",`
    <ul>
      <li>In-stock items can only be cancelled prior to shipment.</li>
      <li>For in-stock cancellations, a restocking fee of up to 20% may be applied to cover processing and handling costs.</li>
      <li>If a restocking fee is not applied, a 3.5% processing fee will be charged to cover payment transaction costs.</li>
      <li>Available to Order items cannot be cancelled.</li>
    </ul>`],
  ["How can I reach customer support?",`
    <p>Have a question, concern, or need assistance with your order? Reach out any time via the chat feature, Instagram DM, or email <a href="mailto:support@hprmmotorsports.com">support@hprmmotorsports.com</a>.</p>`],
];
document.getElementById('faqList').innerHTML=FAQS.map(([q,a])=>`
  <div class="faq"><button>${q}<span class="pls">+</span></button><div class="ans"><div class="ans-in">${a}</div></div></div>`).join('');
document.querySelectorAll('.faq button').forEach(b=>b.addEventListener('click',()=>{
  const f=b.parentElement,ans=f.querySelector('.ans'),open=f.classList.contains('open');
  document.querySelectorAll('.faq').forEach(x=>{x.classList.remove('open');x.querySelector('.ans').style.maxHeight=null;});
  if(!open){f.classList.add('open');ans.style.maxHeight=ans.scrollHeight+'px';}
}));

/* ===================== DRAWER ===================== */
const scrim=document.getElementById('scrim'),drawer=document.getElementById('drawer');
window.lockScroll=function(){var sb=window.innerWidth-document.documentElement.clientWidth;if(sb>0)document.body.style.paddingRight=sb+'px';document.body.classList.add('lock');};
window.unlockScroll=function(){document.body.style.paddingRight='';document.body.classList.remove('lock');};
function openDrawer(){drawer.classList.add('show');scrim.classList.add('show');lockScroll();}
function closeDrawer(){drawer.classList.remove('show');scrim.classList.remove('show');unlockScroll();var c=document.getElementById('menuCrow');if(c)c.classList.remove('fly');}
document.getElementById('openDrawer').addEventListener('click',function(){var c=document.getElementById('menuCrow');if(c){c.classList.remove('fly');void c.offsetWidth;c.classList.add('fly');setTimeout(openDrawer,430);}else{openDrawer();}});
document.getElementById('closeDrawer').addEventListener('click',closeDrawer);
scrim.addEventListener('click',closeDrawer);
document.querySelectorAll('.drawer-link').forEach(a=>a.addEventListener('click',closeDrawer));

/* ===================== SEARCH OVERLAY ===================== */
const searchOv=document.getElementById('searchOv');
document.getElementById('openSearch').addEventListener('click',()=>{searchOv.classList.add('show');lockScroll();setTimeout(()=>searchOv.querySelector('input').focus(),60);});
function closeSearch(){searchOv.classList.remove('show');unlockScroll();}
document.getElementById('closeSearch').addEventListener('click',closeSearch);
searchOv.querySelectorAll('.trending a').forEach(a=>a.addEventListener('click',closeSearch));
document.addEventListener('keydown',e=>{if(e.key==='Escape'){closeSearch();closeDrawer();}});

/* ===================== CAPTURE ===================== */
/* ===================== EMAIL CAPTURE (posts to Shopify customer list, then reveals code) ===================== */
function wireCapture(formId,onOk){
  const f=document.getElementById(formId);if(!f)return;
  f.addEventListener('submit',function(e){
    e.preventDefault();
    const btn=f.querySelector('button[type=submit]');if(btn){btn.disabled=true;btn.textContent='Saving…';}
    fetch(f.action||'/contact',{method:'POST',body:new FormData(f)})
      .then(function(r){if(!r.ok)throw new Error('Submission failed');return r;})
      .then(function(){onOk(f);})
      .catch(function(){if(btn){btn.disabled=false;btn.textContent='Try again';}});
  });
}
wireCapture('capForm',function(f){
  const m=document.getElementById('capMsg');m.style.display='block';
  m.innerHTML='You\'re in. Use <b>WELCOME10</b> for 10% off your first order.';f.reset();
  const btn=f.querySelector('button[type=submit]');if(btn){btn.disabled=false;btn.textContent='Subscribe →';}
});
/* two-step exit capture: email (10%) -> phone/SMS (15%) -> reveal */
(function(){
  var step1=document.getElementById('exitStep1'),step2=document.getElementById('exitStep2'),reveal=document.getElementById('exitReveal');
  function showStep(el){[step1,step2,reveal].forEach(function(s){if(s)s.style.display='none';});if(el)el.style.display='block';}
  function finish(code){var c=document.getElementById('exitCodeValue');if(c)c.textContent=code;showStep(reveal);}
  // step 1: email captured -> carry email into step 2, advance
  wireCapture('exitForm',function(f){
    var email=f.querySelector('input[type=email]'),hidden=document.getElementById('exitPhoneEmail');
    if(email&&hidden)hidden.value=email.value;
    showStep(step2);
  });
  // step 2: phone captured -> reveal the 15% code
  wireCapture('exitPhoneForm',function(){finish('WELCOME15');});
  // skip phone -> reveal the 10% code
  var skip=document.getElementById('exitSkip');
  if(skip)skip.addEventListener('click',function(){finish('WELCOME10');});
  // continue shopping -> close the modal
  var cont=document.getElementById('exitContinue');
  if(cont)cont.addEventListener('click',function(){var m=document.getElementById('exitModal');if(m)m.classList.remove('show');});
})();

/* ===================== EXIT POPUP ===================== */
const modal=document.getElementById('exitModal');
let shown=sessionStorage.getItem('exitShown')==='1';
function openModal(){if(shown)return;shown=true;sessionStorage.setItem('exitShown','1');modal.classList.add('show');}
document.addEventListener('mouseout',e=>{if(!e.relatedTarget&&e.clientY<10)openModal();});
let st=window.scrollY;
window.addEventListener('scroll',()=>{if(window.scrollY<st-40&&window.scrollY<200)openModal();st=window.scrollY;},{passive:true});
setTimeout(()=>{if(!shown)openModal();},28000);
document.getElementById('modalClose').addEventListener('click',()=>modal.classList.remove('show'));
modal.addEventListener('click',e=>{if(e.target===modal)modal.classList.remove('show');});

} /* ===================== END LANDING-ONLY GUARD ===================== */

/* Runs on EVERY page: sticky header + scroll reveal. */
(function(){
  var hdr=document.querySelector('header');
  if(hdr){var s=function(){hdr.classList.toggle('scrolled',window.scrollY>6);};s();window.addEventListener('scroll',s,{passive:true});}
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var sels=['.section-head','.cat-tile','.card','.guar','.ugc','.svc','.spot','.faq','.capture','.interstitial','.kit-summary','.trust'];
  var els=[];
  sels.forEach(function(sel){document.querySelectorAll(sel).forEach(function(e){if(!e.classList.contains('reveal')){e.classList.add('reveal');els.push(e);}});});
  if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('in');});return;}
  ['.prod-grid','.cat-grid','.guar-grid','.ugc-row','.svc-grid'].forEach(function(g){
    var c=document.querySelector(g);if(!c)return;
    Array.prototype.slice.call(c.children).forEach(function(ch,i){if(ch.classList.contains('reveal'))ch.style.transitionDelay=((i%4)*0.08)+'s';});
  });
  var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('in');io.unobserve(x.target);}});},{threshold:0.12,rootMargin:'0px 0px -7% 0px'});
  els.forEach(function(e){io.observe(e);});
})();
